<script setup lang="ts">
import { AuthQuick } from "@/components/Auth";
import { Icon } from "@/components/Ui";

interface Props {
  title?: string;
  card?: any;
  googleButtonEvent?: string;
  telegramButtonEvent?: string;
  emailButtonEvent?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div :class="$style.root">
    <template v-if="!$slots.card">
      <Icon
        v-if="props.card.svg"
        :name="`pst-${props.card.svg}`"
        path="cards"
        :class="$style.card"
      />
      <nuxt-img v-else :src="`/img/cards/${props.card.image}`" alt="" format="webp" :class="$style.card" />
    </template>
    <template v-else>
      <div :class="$style.card">
        <slot name="card" />
      </div>
    </template>
    <AuthQuick
      size="default"
      color="grey"
      google
      apple
      telegram
      whatsapp
      with-login
      :google-button-event="props.googleButtonEvent"
      :telegram-button-event="props.telegramButtonEvent"
      :email-button-event="props.emailButtonEvent"
    >
      <template #title>
        {{ props?.title || $t("cards.authTitle") }}
      </template>
    </AuthQuick>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[40px] p-8 md:p-10 w-full;
  @apply grid items-start grid-flow-row auto-rows-min grid-cols-1 lg:gap-x-[30px] lg:grid-cols-[440px_minmax(200px,1fr)];
  @apply bg-neutral-100;

}

.card {
  @apply w-full max-w-[440px] mb-10 mx-auto lg:m-0 lg:row-span-6;

  & svg {
    @apply h-full w-full;
  }
}
</style>
